
import { BaseBackgroundEffect } from '../BaseBackgroundEffect';
import { BackgroundContext } from '../BackgroundEffect';

export class SolidBackground extends BaseBackgroundEffect {
    public render(bc: BackgroundContext): void {
        const { ctx, width, height } = bc;
        ctx.fillStyle = this.getPrimaryColor(bc);
        ctx.fillRect(0, 0, width, height);
    }
}
